import React from "react";
import RegistrationPopup from "../Common/RegistrationPopup";
import config from '../../config';
const fleetcontrolfirmware = (props) => {
  return (
    <>
     <div className="row">
        <div className="col-lg-12 mb-lg-5">
          <h2>
          <strong>Fleet Control </strong> Firmware
          </h2>
          <div className="card  mb-5 ">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-lg-12">
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <h3 className="text-dark">
                        <small className="d-block mb-3 text-black-50">
                          Version
                        </small>{" "}
                        <span>1.1.0</span>
                      </h3>
                    </div>
                    <div className="col-md-5 d-none">
                      <h3 className="text-dark">
                        <small className="d-block mb-3 text-black-50">
                          Build
                        </small>
                        --
                      </h3>
                    </div>
                    <div className="col-md-4">
                      <h3 className="text-dark">
                        <small className="d-block mb-3 text-black-50">
                          Updated on
                        </small>{" "}
                        2026-04-10
                      </h3>
                    </div>
                  </div>
                  <div>
                    <h2>
                      <strong>Compatibility Notice:</strong>
                    </h2>
                    <ul>
                     <li>This firmware must be used with Monitor Firmware 6.3.2 Beta 0 or later</li>
                    </ul>
                    <h2>
                      <strong>Supported Platforms</strong>
                    </h2>
                    <ul>
                      <li>
                        Windows (x64)
                      </li>
                      <li>
                       macOS
                      </li>
                    </ul>
                  </div>
                  <div className="btn-col">
                    {/*<a href="#" className="btn btn-outline-dark">Learn More</a>*/}
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      data-toggle="modal"
                      data-target="#RedModal-v6-1-0-main"
                    >
                      Learn More
                    </button>
                    <a
                      target="_blank"
                      onClick={() =>
                        props.directdownloadlink(
                          `${config.downloadFirmwareUrl}fleetcontrol/smallHD_fleet_control_mac_v1-1-0.zip`
                        )
                      }
                      className="btn btn-primary text-white"
                    >
                      Download MacOS
                    </a>
                    <a
                      target="_blank"
                      onClick={() =>
                        props.directdownloadlink(
                          `${config.downloadFirmwareUrl}fleetcontrol/smallHD_fleet_control_windows-x64-v1-1-0.exe`
                        )
                      }
                      className="btn btn-primary text-white"
                    >
                      Download Windows
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


{/* modals */}
      <div
        className="modal fade beta-firmware-modal"
        // aria-hidden="true"
        id="RedModal-v6-1-0-main"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title" id="exampleModalLabel">
                <strong>Fleet Control Firmware</strong>{" "}
                <span>v1.1.0</span>{" "}
              </h2>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h2>
                  <strong>Compatibility Notice</strong>
                </h2>
                <ul>
                  <li>This firmware must be used with Monitor Firmware 6.3.2 Beta 0 or later</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2>
                  <strong>Supported Platforms</strong>
                </h2>
                <ul className="list-txt">
                  <li>Windows (x64)</li>
                  <li>macOS</li>
                </ul>
              </div>

              <div className="mb-4">
                <h2>
                  <strong>New Features</strong>
                </h2>
                <ul className="list-txt">
                <li>Shared Pages
                    <ul>
                        <li>Create pages that automatically appear across all connected monitors for a unified setup</li>
                    </ul>
                </li>
                <li>Mirroring
                    <ul>
                        <li>Link multiple monitors to behave as a single, synchronized display group</li>
                    </ul>
                </li>
                <li>Syncing
                    <ul>
                        <li>Easily replicate the configuration of one monitor across several others with a single action</li>
                    </ul>
                </li>
                </ul>
              </div>
              <div className="mb-4">
                <h2>
                  <strong>Improvements</strong>
                </h2>
                <ul className="list-txt">
                  <li>Expanded support for additional settings sections, including compatibility with Color Pipe configurations</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2><strong>Bug Fixes</strong></h2>
                <ul className="list-txt">
                  <li>Improved overall system stability and performance across connected devices</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2><strong>Known Limitations</strong></h2>
                <h5>Mirroring</h5>
                <ul className="list-txt">
                  <li>Mirroring does not replicate all monitor configuration settings. The following items are not updated when mirroring:
                    <ul>
                        <li>Multiview Pages</li>
                        <li>Display {'>'} Calibration</li>
                        <li>User {'>'} Date & Time</li>
                        <li>User {'>'} Monitor ID</li>
                        <li>System {'>'} Network {'>'} Enable Wi‑Fi</li>
                        <li>System {'>'} Licenses</li>
                        <li>Capture {'>'} Image Capture (Reset Capture Number)</li>
                        <li>System {'>'} Firmware (current version and updates)</li>
                        <li>System {'>'} Reformat Drives</li>
                        <li>System {'>'} Factory Reset</li>
                    </ul>
                  </li>
                  <li>Local monitor control during mirroring is available only on the Primary monitor</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2><strong>App Control</strong></h2>
                <span>Not all monitor settings can be adjusted through the Fleet Control app. The following items are currently excluded:</span>
                <ul className="list-txt">
                  <li>Interface {'>'} Language</li>
                  <li>Display {'>'} Burn‑in Recovery</li>
                  <li>Controls {'>'} Image Rotate</li>
                  <li>UI Orientation</li>
                  <li>Match Menu to Video</li>
                  <li>Calibration</li>
                  <li>Feed {'>'} Input Config</li>
                </ul>
              </div>
              <div className="mb-4">
                <h2><strong>Input & Output Configuration</strong></h2>
                <span>The in‑monitor input and output configuration offers more advanced options than the Fleet Control app.</span>
                <span>The app does not currently support output processing configuration or display the dynamic output routing diagram available on the monitor interface</span>
              </div>
              <div className="mb-4">
                <h2><strong>File Access</strong></h2>
                <span>Fleet Control does not currently provide a way to browse or transfer files directly from connected monitors to the host computer, except through profile saving, mirroring, or syncing actions</span>
              </div>
            </div>
            <div className="modal-footer">
              <div className="btn-col">
                <a
                  target="_blank"
                  onClick={() =>
                    props.directdownloadlink(
                      `${config.downloadFirmwareUrl}fleetcontrol/smallHD_fleet_control_mac_v1-1-0.zip`
                    )
                  }
                  className="btn btn-primary text-white"
                  data-dismiss="modal" aria-label="Close"
                >
                  Download MacOS
                </a>
                <a
                  target="_blank"
                  onClick={() =>
                    props.directdownloadlink(
                      `${config.downloadFirmwareUrl}fleetcontrol/smallHD_fleet_control_mac_v1-1-0.zip`
                    )
                  }
                  className="btn btn-primary text-white"
                  data-dismiss="modal" aria-label="Close"
                >
                  Download Windows
                </a>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </>
  );
};

export default fleetcontrolfirmware;